import c from 'classnames';
import { MouseEvent } from 'react';
import { Icon } from '../Icon';
import styles from './Checkbox.module.css';

type CheckboxProps = {
  checked: boolean;
  onCheck: (e: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  disabled?: boolean;
};

export function Checkbox({ checked, onCheck, disabled }: CheckboxProps) {
  return (
    <button
      onClick={onCheck}
      className={c(
        styles.button,
        checked && styles.checked,
        disabled && styles.disabled,
      )}
      disabled={disabled}
      role='checkbox'
      aria-checked={checked}
    >
      {checked ? (
        <Icon
          name='simpleCheck'
          preserveColors
          size={'s'}
          className={styles.check}
        />
      ) : null}
    </button>
  );
}
